import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

export default function ViewDetails({ closeModal, alert, user }) {
  console.log(user);
  return (
    <React.Fragment>
      <div className="view-details-modal">
      <div className="">
        <h4 className="modal-title" style={{ color: "#000" }}>
          Personal Details
        </h4>
        <hr />
      </div>
      <div className="form-group row">
        {/* <div className="col-md-4 col-xs-12"> */}
        <input type="hidden" id="slug" />
        <div className="col">
          <label>First Name</label>
          <input
            type="text"
            className="form-control item"
            id="profile_first_name"
            placeholder="First Name"
            value={user.first_name}
            disabled
          />
        </div>
        <div className="col">
          <label>Last Name</label>
          <input
            type="text"
            className="form-control item"
            id="profile_last_name"
            placeholder="Last Name"
            value={user.last_name}
            disabled
          />
        </div>
        <div className="col">
          <label>Middle Name</label>
          <input
            type="text"
            className="form-control item"
            id="profile_middle_name"
            placeholder="Middle Name"
            value={user.middle_name}
            disabled
          />
        </div>
        {/* </div> */}
      </div>

      <div className="form-group row">
        <div className="col">
          <label>Preferred Name</label>
          <input
            type="text"
            className="form-control item"
            id="profile_preferred_name"
            placeholder="Preferred name"
            value={user.preferred_name !== null ? user.preferred_name : ""}
            disabled
          />
        </div>

        <div className="col">
          <label>Employee Number</label>
          <input
            type="text"
            className="form-control item"
            id="profile_employee_number"
            placeholder="Employee Number"
            value={user.employee_number}
            disabled
          />
        </div>

        <div className="col">
          <label>Date Of Birth</label>
          <input
            type="text"
            className="form-control item"
            id="profile_date_of_birth"
            placeholder="Date of birth"
            value={user.date_of_birth}
            disabled
          />
        </div>
      </div>

      <div className="form-group row">
        <div className="col">
          <label>Date Of Employment</label>
          <input
            type="text"
            className="form-control item"
            id="profile_date_of_employment"
            placeholder="Date of employment"
            value={user.date_of_employment}
            disabled
          />
        </div>
        <div className="col">
          <label>Gender</label>
          <input
            type="text"
            className="form-control item"
            id="profile_gender"
            placeholder="Gender"
            value={user.gender}
            disabled
          />
        </div>
        <div className="col">
          <label>Mobile Number</label>
          <input
            type="text"
            className="form-control item"
            id="profile_mobile"
            placeholder="Mobile No"
            value={user.mobile_number !== null ? user.mobile_number : ""}
            disabled
          />
        </div>
      </div>

      <div className="">
        <h4 style={{ color: "#000" }}>Company Details</h4>
      </div>
      <hr />
      <div className="form-group row">
        {/* <div className="col-md-6 col-xs-12"> */}
        <div className="col">
          <label>Role</label>
          <input
            type="text"
            className="form-control item"
            id="profile_role"
            placeholder="Role"
            value={user.roles.name}
            disabled
          />
        </div>
        {/* </div> */}
        {/* <div className="col-md-6 col-xs-12"> */}
        <div className="col">
          <label>Job Title</label>
          <input
            type="text"
            className="form-control item"
            id="profile_job_title"
            placeholder="Job title"
            value={user.job_title !== null ? user.job_title.name : ""}
            disabled
          />
        </div>
        {/* </div> */}

        <div className="col">
          <label>Line Manager</label>
          <input
            type="text"
            className="form-control item"
            id="profile_line_manager"
            placeholder="Line Manager"
            disabled
          />
        </div>
        <div className="col">
          <label>Employee Email</label>
          <input
            type="text"
            className="form-control item"
            id="profile_employee_email"
            placeholder="Employee Email"
            value={user.email}
            disabled
          />
        </div>
      </div>
      {/* </div> */}

      <div className="">
        <h4 style={{ color: "#000" }}>Financial Details</h4>
      </div>
      <hr />

      <div className="form-group row">
        <div className="col">
          <label>Account Number</label>
          <input
            type="number"
            className="form-control item"
            id="profile_account_number"
            placeholder="Account No"
            value={
              user.account_details.length > 0
                ? user.account_details[0].account_number
                : ""
            }
            disabled
          />
        </div>

        <div className="col">
          <label>Bank</label>
          <input
            type="text"
            className="form-control item"
            id="profile_bank"
            placeholder="Bank"
            value={
              user.account_details.length > 0
                ? user.account_details[0].bank_name
                : ""
            }
            disabled
          />
        </div>
      </div>

      <div className="">
        <h4 style={{ color: "#000" }}>Next Of Kin Details</h4>
      </div>
      <hr />

      <div className="form-group row">
        <div className="col">
          <label> Name</label>
          <input
            type="text"
            className="form-control item"
            id="profile_next_of_kin"
            placeholder="Next of kin."
            value={
              user.next_of_kins.length > 0 ? user.next_of_kins[0].fullname : ""
            }
            disabled
          />
        </div>
        <div className="col">
          <label> Contact</label>
          <input
            type="text"
            className="form-control item"
            id="profile_contact_next_of_kin"
            placeholder="Next of Kin. Contact"
            value={
              user.next_of_kins.length > 0
                ? user.next_of_kins[0].phonenumber
                : ""
            }
            disabled
          />
        </div>

        <div className="col">
          <label>Address</label>
          <input
            type="text"
            className="form-control item"
            id="profile_address_next_of_kin"
            placeholder="Next of Kin. Address"
            value={
              user.next_of_kins.length > 0 ? user.next_of_kins[0].address : ""
            }
            disabled
          />
        </div>
        <div className="col">
          <label>Relationship</label>
          <input
            type="text"
            className="form-control item"
            id="profile_relationship_next_of_kin"
            placeholder="Next of Kin. relationship"
            value={
              user.next_of_kins.length > 0
                ? user.next_of_kins[0].relationship
                : ""
            }
            disabled
          />
        </div>
      </div>

      <hr />

      <div className="form-group row">
        <div className="col">
          <button
            type="button"
            className="btn btn-danger btn-sm"
            onClick={closeModal}
          >
            Close
          </button>
        </div>
        <div className="col-md-10">
          <Link
          to={`/dashboard/employee/edit/${user.slug}`}
          className="dropdown-item"
          href="employee-management.html#"
            type="submit"
            className="btn btn-block nt-button-color-default btn-sm"
          >
            Edit{" "}
          </Link>
        </div>
      </div>
      </div>
    </React.Fragment>
      
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/modals/view_details.js